export default "__VITE_ASSET__Er1jShvq__"